import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { MagentoLinkedService } from 'app/model/linkedservice/magento.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { MagentoCopySource } from 'app/model/pipeline/copysource/magento.copysource';
import { useEncryptedEndpointsRadioSwitch } from 'app/registries/linked-service/linked-service-shared-fields';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const magentoMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(MagentoLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Magento_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-magento'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(MagentoCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.Magento_LinkedService_Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            label: stringResources.ModelName_AccessToken,
            bind: 'accessToken',
            child: {
                type: 'password',
                label: stringResources.ModelName_AccessToken,
                isLabelVertical: true,
                required: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Magento_DisplayText),
                stringResources.ModelName_AccessToken)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
